import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { StudyState } from './modules/types';
import { Series } from '@models/Series';
import { Study } from '@models/Study';
import { SeriesSelection, StudyState } from 'config/browserConfig';
import { SortOption, StudyFilter, StudyViewState } from 'config/studyConfig';

const initialStudyViewState : StudyViewState = {
  sortOption: {},
  filters: {},
  currentPage: 1,
  perPage: 20
};

const initialState: StudyState = {
  studies: [],
  series: {},
  loading: false,
  error: null,
  selectedStudyId: null,
  recentStudies: [],
  studyViewState: initialStudyViewState,
  seriesSelections: []
};

const studySlice = createSlice({
  name: 'study',
  initialState,
  reducers: {
    // resetSelectedStudyId(state) {
    //   state.selectedStudyId = null;
    // },
    setSelectedStudy(state, action: PayloadAction<Study>) {
      const study = action.payload;
      // 기존 스터디가 있는지 확인
      const index = state.recentStudies.findIndex(item => item.id === study.id);

      if (index !== -1) {
        state.recentStudies.splice(index, 1); // 기존 위치에서 제거
      }

      // 맨 앞에 추가
      state.recentStudies.unshift(study);

      // 들어온 스터디 선택
      state.selectedStudyId = study.id;
      // state.selectedStudyId = action.payload;
    },
    setStudies(state, action: PayloadAction<Study[]>) {
      state.studies = action.payload;
    },
    setSeries(state, action: PayloadAction<Series[]>) {
      const studyId = state.selectedStudyId;
      if (!studyId) return;
      // 최신 Series 들어왔을 때, 기존에 있는 데이터 덮어씌우기
      state.series[studyId] = action.payload;
    },
    setFilters(state, action: PayloadAction<StudyFilter>) {
      state.studyViewState.filters = action.payload;
    },
    setSortOptions(state, action: PayloadAction<SortOption>) {
      state.studyViewState.sortOption = action.payload;
    },
    setPagination: (
      state,
      action: PayloadAction<{
        currentPage?: number;
        perPage?: number;
      }>
    ) => {
      if (action.payload.perPage !== undefined) {
        state.studyViewState.perPage = action.payload.perPage;
        state.studyViewState.currentPage = 1;
      } else if (action.payload.currentPage !== undefined) {
        state.studyViewState.currentPage = action.payload.currentPage;
      }
    },
    setSeriesSelections(state, action: PayloadAction<SeriesSelection[]>) {
      state.seriesSelections = action.payload;
    },

    // addRecentStudy(state, action: PayloadAction<Study>) {
    //   const study = action.payload;
    //   // 기존 스터디가 있는지 확인
    //   const index = state.recentStudies.findIndex(item => item.id === study.id);

    //   if (index !== -1) {
    //     state.recentStudies.splice(index, 1); // 기존 위치에서 제거
    //   }

    //   // 맨 앞에 추가
    //   state.recentStudies.unshift(study);

    //   // 들어온 스터디 선택
    //   state.selectedStudyId = study.id;

    //   // // 없을때만 추가함.
    //   // if (
    //   //   !state.recentStudies.some(
    //   //     (item) => item.studyInstanceUid == study.studyInstanceUid,
    //   //   )
    //   // ) {
    //   //   state.recentStudies.unshift(study);
    //   // }

    //   // // 들어온 스터디를 선택
    //   // state.selectedStudyId = study.id;
    //   // console.log(state.selectedStudyId)
    // },
    deleteStudy(state, action: PayloadAction<Study>) {
      const target = action.payload;
      // 있을테니 지우기만
      state.recentStudies = state.recentStudies.filter(
        (study) => study.studyInstanceUid !== target.studyInstanceUid,
      );
      if(state.selectedStudyId === target.studyId){
        state.selectedStudyId = null;
      }
    },
    // 필요시
    clearRecentStudies(state) {
      state.recentStudies = [];
    },

    clearStudyViewState(state) {
      state.studyViewState = initialStudyViewState;
    },

    clearStudy(state) {
      state.studies = [];
    },

    clearSeries(state) {
      state.series = {};
    }
  },
});

export const {
  // setSelectedStudyId,
  // resetSelectedStudyId,
  setSelectedStudy,
  setStudies,
  setSeries,
  setFilters,
  setSortOptions,
  setPagination,
  setSeriesSelections,
  // addRecentStudy,
  deleteStudy,
  clearRecentStudies,
  clearStudyViewState,
  clearStudy,
  clearSeries
} = studySlice.actions;

export default studySlice.reducer;
